<template>
  <div class="filters-menu-loading-container">
    <div class="filter-loading d-flex flex-row justify-space-between">
      <div class="d-flex flex-row">
        <div class="d-flex flex-row mr-6">
          <div class="period-component mr-4">
            <v-skeleton-loader type="text"></v-skeleton-loader>
          </div>
          <div class="period-component">
            <v-skeleton-loader type="text"></v-skeleton-loader>
          </div>
        </div>
        <div class="d-flex flex-row mr-4">
          <div class="filter-component mr-4">
            <v-skeleton-loader type="text"></v-skeleton-loader>
          </div>
          <div class="filter-component">
            <v-skeleton-loader type="text"></v-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div class="select-component mr-4">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </div>
        <div class="select-component">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'FiltersMenuLoadingState',
}
</script>

<style lang="scss" scoped>
.filters-menu-loading-container {
  .filter-loading {
    .period-component {
      width: 200px;
    }
    .filter-component {
      width: 94px;
    }
    .select-component {
      width: 72px;
    }
  }
  .line {
    width: 100%;
    height: 2px;
    background-color: $cinza-l80 !important;
    margin-top: 25px;
  }
}
.v-skeleton-loader__text {
  height: 40px !important;
  background-color: $cinza-l80 !important;
}
</style>
